export function* uniqueIdGenerator(prefix: string) {
  let i = 0;
  while (true) {
    ++i;
    yield `${prefix}-${i}`;
  }
}
